function LoadingSpinner({ strokeColor = '#fa6d2c', size = 40, strokeWidth = 24 }) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width={size} height={size}>
            <defs>
                <radialGradient id='a12' cx='.66' fx='.66' cy='.3125' fy='.3125' gradientTransform='scale(1.5)'>
                    <stop offset='0' stopColor={strokeColor}></stop>
                    <stop offset='.3' stopColor={strokeColor} stopOpacity='.9'></stop>
                    <stop offset='.6' stopColor={strokeColor} stopOpacity='.6'></stop>
                    <stop offset='.8' stopColor={strokeColor} stopOpacity='.3'></stop>
                    <stop offset='1' stopColor={strokeColor} stopOpacity='0'></stop>
                </radialGradient>
            </defs>

            <circle
                style={{ transformOrigin: 'center' }}
                fill='none'
                opacity='.2'
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                cx='100'
                cy='100'
                r='70'
            />

            <circle
                style={{ transformOrigin: 'center' }}
                fill='none'
                stroke='url(#a12)'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeDasharray='200 1000'
                strokeDashoffset='0'
                cx='100'
                cy='100'
                r='70'
            >
                <animateTransform 
                    type='rotate' 
                    attributeName='transform' 
                    calcMode='spline' 
                    dur='1' 
                    values='360;0' 
                    keyTimes='0;1' 
                    keySplines='0 0 1 1' 
                    repeatCount='indefinite' 
                />
            </circle>
        </svg>
    );
}

export default LoadingSpinner;